import { StylovyzeIconProps } from '@innovyze/stylovyze';
import React from 'react';

const RehabIconLarge: React.FC<StylovyzeIconProps> = ({
	color,
	...props
}: StylovyzeIconProps) => {
	return (
		<svg
			width="61"
			height="61"
			viewBox="0 0 61 61"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect
				x="1.95825"
				y="1.95825"
				width="20.2083"
				height="20.2083"
				stroke="#007CA0"
				strokeWidth="3"
			/>
			<rect
				x="1.95825"
				y="38.8333"
				width="20.2083"
				height="20.2083"
				stroke="#007CA0"
				strokeWidth="3"
			/>
			<rect
				x="38.8333"
				y="38.8333"
				width="20.2083"
				height="20.2083"
				stroke="#007CA0"
				strokeWidth="3"
			/>
			<rect
				x="10.8333"
				y="23.125"
				width="2.45833"
				height="14.75"
				fill="#007CA0"
			/>
			<rect
				x="23.125"
				y="50.1667"
				width="2.45833"
				height="14.75"
				transform="rotate(-90 23.125 50.1667)"
				fill="#007CA0"
			/>
			<path
				d="M9.82297 50.5499L6.90903 47.4921L5.91675 48.526L9.82297 52.6251L18.2084 43.8257L17.2231 42.7917L9.82297 50.5499Z"
				fill="#007CA0"
			/>
			<path
				d="M42.7916 44.0297L44.0295 42.7917L48.9374 47.6996L53.8453 42.7917L55.0833 44.0297L50.1754 48.9376L55.0833 53.8455L53.8453 55.0834L48.9374 50.1755L44.0295 55.0834L42.7916 53.8455L47.6995 48.9376L42.7916 44.0297Z"
				fill="#007CA0"
			/>
		</svg>
	);
};

export default RehabIconLarge;
